var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7.30435V7.30435H0V0Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34783 0H15.6522V7.30435H8.34783V0Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6957 0H24V7.30435H16.6957V0Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.34783H7.30435V15.6522H0V8.34783Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34783 8.34783H15.6522V15.6522H8.34783V8.34783Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6957 8.34783H24V15.6522H16.6957V8.34783Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.6957H7.30435V24H0V16.6957Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34783 16.6957H15.6522V24H8.34783V16.6957Z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6957 16.6957H24V24H16.6957V16.6957Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiment);
export default __webpack_public_path__ + "static/media/Experiment.1ace6af4452fc5462f0cc11906fc507e.svg";
export { ForwardRef as ReactComponent };